import styled from 'styled-components'

import { Label } from '../../shared-form-styles'

export const LabelWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const IconSelectorLabel = styled(Label)`
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const IconSelectorLabelNoGroups = styled(Label)`
  margin-bottom: 0;
`

export const IconName = styled.span`
  color: ${o => o.theme.color.deprecated.gray.dark};
  font-size: 11px;
  letter-spacing: 0.5px;
  margin-inline-start: 8px;
`
